import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/billing/payments')({
  staticData: { crumb: { parents: [{ label: 'Billing' }], label: 'Payments' } },
})
